import { useCallback } from 'react';

export const useDisplayFormikMessage = () => {
  return useCallback((formik, key) => {
    return formik.touched[key] && formik.errors[key] ? formik.errors[key] : '';
  }, []);
};
